import React, { useEffect } from "react";

import mailIcon from "../../assets/images/mail.png";

// import BankDetails from "../SettingsForAdmin/AdminManageRestaurant/componenets/BankDetails";
// import WidthdrawDetails from "../SettingsForAdmin/AdminManageRestaurant/componenets/WidthdrawDetails";
import TopHeader from "../../components/TopHeader.tsx";
import RichTextEditor from "../components/RichTextEditor.tsx";
import RequestMail from "./RequestMail.tsx";
import "./AdminCommunication.css";
import AdminTextEditor from "./AdminTextEditor.tsx";
import AdminSentMail from "./AdminSentMail.tsx";
import AdminDraftEmail from "./AdminDraftEmail.tsx";
import axios from "axios";
import jwtDecode from "jwt-decode";

const AdminCommunication = () => {
  const [menuSelection, setMenuSelection] = React.useState(0);
  const [editingDraftEmail, setEditingDraftEmail] = React.useState(null);
  const [restaurants, setRestaurant] = React.useState([]);
  const [selectedchildRestaurant, setselectedchildRestaurant] = React.useState(
    JSON.parse(localStorage.getItem("restaurant")),
  );
  const apiAddress = process.env.REACT_APP_SECRET;
  const restaurant = localStorage.getItem("restaurant");

  const loadDataForRestaurant = async () => {
    let restaurant = JSON.parse(localStorage.getItem("parentrestaurant"));
    const user = jwtDecode(localStorage.getItem("gotasteadmintoken"));
    console.log("restaurant", restaurant);
    console.log("user", user);

    if (!restaurant && user.UserRole == "Admin" && user.UserName === "Leo") {
      alert("Please select a restaurant first.");
    }
    axios
      .get(
        apiAddress +
          "/api/Restaurant/getrestaurantdetailsbyidfortable/" +
          "2e528a48-2121-48bd-97d4-b6ec8865bff2" +
          "/" +
          restaurant.id,
      )
      .then((response) => {
        console.log(response.data);
        var list = [];
        response.data.map((dt, i) => {
          var obj = {
            id: dt.id,
            name: dt.name,
            address: dt.addressLine1,
            PhoneNumber: dt.phoneNumber,
            Email: dt.emailAddress,
          };
          list.push(obj);
        });
        setRestaurant(list);
      });
  };

  useEffect(() => {
    loadDataForRestaurant();
  }, [restaurant]);

  const handleEditDraft = (email) => {
    setEditingDraftEmail(email);
    setMenuSelection(0);
  };

  const handleDraftEditComplete = () => {
    setEditingDraftEmail(null);
    setMenuSelection(3);
  };

  return (
    <div className="admin-communication">
      <TopHeader />

      <div className="d-flex" style={{ height: "calc(100vh - 60px)" }}>
        {/* ===== Sidebar ===== */}
        <div
          className="sidebar border-end"
          style={{
            width: "13rem",
            minWidth: "13rem",
            height: "100%",
          }}
        >
          <h6 className="ms-3 mt-2" style={{ fontSize: "13px" }}>
            <b>Mail Settings</b>
          </h6>
          <hr style={{ margin: ".5rem" }} />

          <div
            className={`admin_communication__menuItem ${menuSelection === 0 ? "active" : ""}`}
            onClick={() => {
              setEditingDraftEmail(null);
              setMenuSelection(0);
            }}
          >
            <div className="admin_communication__menu-inner">
              <img src={mailIcon} alt="" />
              <p>Create Email</p>
            </div>
          </div>

          <div
            className={`admin_communication__menuItem ${menuSelection === 1 ? "active" : ""}`}
            onClick={() => setMenuSelection(1)}
          >
            <div className="admin_communication__menu-inner">
              <img src={mailIcon} alt="" />
              <p>Request Mails</p>
            </div>
          </div>
          <div
            className={`admin_communication__menuItem ${menuSelection === 2 ? "active" : ""}`}
            onClick={() => setMenuSelection(2)}
          >
            <div className="admin_communication__menu-inner">
              <img src={mailIcon} alt="" />
              <p> Admin Sent Mails</p>
            </div>
          </div>
          <div
            className={`admin_communication__menuItem ${menuSelection === 3 ? "active" : ""}`}
            onClick={() => setMenuSelection(3)}
          >
            <div className="admin_communication__menu-inner">
              <img src={mailIcon} alt="" />
              <p> Admin Drafts</p>
            </div>
          </div>
        </div>

        {/* ===== Content Area (Remaining Width) ===== */}
        <div
          className="content-area"
          style={{
            flex: 1,
            height: "100%",
            overflow: "auto",
            padding: "1rem",
          }}
        >
          {menuSelection === 0 && (
            // selectedchildRestaurant &&
            <AdminTextEditor
              restaurantName={selectedchildRestaurant?.name}
              draftEmail={editingDraftEmail}
              onDraftEditComplete={handleDraftEditComplete}
            />
          )}

          {menuSelection === 1 && <RequestMail />}
          {menuSelection === 2 && <AdminSentMail />}
          {menuSelection === 3 && (
            <AdminDraftEmail onEditDraft={handleEditDraft} />
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminCommunication;
